import React from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown, Check } from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "./ui/dropdown-menu";

const LANGS = [
    { code: "en", label: "EN", name: "English" },
    { code: "fr", label: "FR", name: "Français" },
    { code: "ht", label: "HT", name: "Kreyòl" },
];

export const LanguageSwitcher = ({ variant = "default" }) => {
    const { i18n } = useTranslation();
    const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    data-testid="lang-switcher-btn"
                    className={
                        variant === "minimal"
                            ? "flex items-center gap-1 text-sm font-semibold text-foreground hover:text-muted-foreground transition-colors"
                            : "flex items-center gap-2 px-3 py-2 rounded-full border-2 border-border text-sm font-semibold hover:bg-muted transition-colors"
                    }
                >
                    <span>{current.label}</span>
                    <ChevronDown className="h-3 w-3" />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="min-w-[160px]">
                {LANGS.map((lang) => (
                    <DropdownMenuItem
                        key={lang.code}
                        data-testid={`lang-option-${lang.code}`}
                        onClick={() => i18n.changeLanguage(lang.code)}
                        className="flex items-center justify-between cursor-pointer"
                    >
                        <span className="font-medium">{lang.name}</span>
                        {current.code === lang.code && <Check className="h-4 w-4" />}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
